import isEmpty from 'lodash/isEmpty';
import { MenuProps } from 'antd/lib/menu';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import styles from './actions.module.less';

export type Action = Readonly<{
	/* callback action */
	onAction: () => void;
	/* label for the action */
	label: string;
	/* is a bad action */
	isDanger?: boolean;
}>;

type ActionsProps = Readonly<{
	/** list of actions */
	actions: Action[];
}>;

/**
 * More dropdown of actions nested in a dropdown menu
 * @param actions
 * @constructor
 */
export default function Actions({ actions }: ActionsProps) {
	if (isEmpty(actions)) return null;
	const menuProps: MenuProps = {
		className: styles.menu,
		items: actions.map(({ label, isDanger }, key) => ({
			key,
			label,
			className: isDanger ? styles.menuDanger : undefined,
		})),
		onClick: ({ key }) => actions[+key].onAction(),
	};
	return (
		<Dropdown trigger={['click']} menu={menuProps}>
			<Button
				type="link"
				size="small"
				name="more"
				block
				icon={<MoreOutlined style={{ fontSize: '1.5em' }} />}
			/>
		</Dropdown>
	);
}
